import { useCallback, useMemo, useState } from 'react';
import { is } from '../providers/creative/is.js';

/**
 *
 * @param initialSlideIndex
 * @param schema
 * @return {[number, (target: any) => void]}
 */
export function useSlideNavigation(initialSlideIndex, schema) {
  const [activeSlide, setActiveSlide] = useState(initialSlideIndex);
  const targetAlias = useMemo(
    () => ({
      next: (number) => Math.min(schema.slides.length - 1, number + 1),
      prev: (number) => Math.max(0, number - 1),
      /*
        // Does not have request for such case at the moment
        first: () => 0,
        last: () => schema.slides.length - 1,
    */
      back: (number) =>
        schema.slides.findLastIndex((slide, index) => {
          return index < number && is.slideDisplayMode.fullscreen(slide);
        }),
      null: () => -1,
    }),
    [schema],
  );

  /**
   *
   * @type {(function(target: any): void)}
   */
  const onRequestSlideNavigate = useCallback(
    (navigateTarget) => {
      const slideNumber = () => Number(navigateTarget) - 1;
      setActiveSlide((currentIndex) => {
        const applied = targetAlias[navigateTarget] || slideNumber;
        const nextIndex = applied(currentIndex);
        if (isNaN(nextIndex)) {
          return currentIndex;
        }

        if (nextIndex >= 0 && !schema.slides[nextIndex]) {
          return currentIndex;
        }

        if (nextIndex === -1) {
          return null;
        }
        return nextIndex;
      });
    },
    [schema, targetAlias],
  );

  return [activeSlide, onRequestSlideNavigate];
}
